import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CreateNew from "../../Components/Button/CreateNew";
import CurrentLatestSeatPlanTable from "../../Components/Tables/CurrentLatestSeatPlanTable";
import AuthModal from '../../Components/Modal/AuthenticateModal';
import { toast } from 'sonner';

interface SeatPlanItem {
  id: number;
  ticket_group_code: string;
}

export default function SeatPlan() {
  const [items, setItems] = useState<SeatPlanItem[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const isMounted = useRef(true);
  const [itemToDelete, setItemToDelete] = useState<number | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const openAuthModal = () => {
    setIsModalOpen(true); 
  };
	
  const closeAuthModal = () => {
    setIsModalOpen(false); 
  };

  useEffect(() => {
    isMounted.current = true;

    const fetchData = async () => {
      try {
        const response = await axios.get("https://stagingbackend.pulp.ph/api/v1/pulpliveworld/seatPlan",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );

        if (isMounted.current) {
          setItems(response.data.seat_plan);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
    
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleEdit = (id: number) => {
    navigate(`/update/seat-plan`, { state: { id } });
  };

  const handleDelete = (id: number) => {
    setItemToDelete(id);
    openAuthModal();
  };

  const confirmDelete = async () => {
    if (itemToDelete === null) return;

    try {
      const authToken = localStorage.getItem("authToken");
      await axios.delete(
        `https://stagingbackend.pulp.ph/api/v1/pulpliveworld/seatPlan/${itemToDelete}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      toast.success(<p className="text-[16px]">Content was deleted successfully!</p>, {
        duration: 1500,
      });
      closeAuthModal();
      setItemToDelete(null);
      setTimeout(() => {
        window.location.reload(); 
      }, 1600);
    } catch (error) {
      console.error("Unable to delete. Please try again.", error);

      toast.error(<p className="text-[16px]">Unable to delete. Please try again.</p>, {
        duration: 1500,
      });
    }
  };

  // const handleDelete = async (id: number) => {
  //   try {
  //     const authToken = localStorage.getItem("authToken");
  //     if (!authToken) {
  //       alert("Authentication token not found!");
  //       return;
  //     }

  //     const confirmDelete = window.confirm(
  //       "Are you sure you want to delete this content?"
  //     );
  //     if (!confirmDelete) {
  //       return;
  //     }

  //     await axios.delete(
  //       `https://stagingbackend.pulp.ph/api/v1/pulpliveworld/seatPlan/${id}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
  //         },
  //       }
  //     );
  //     alert("Content Deleted Successfully !!");
  //     setItems((prevItems) => prevItems.filter((item) => item.id !== id));
  //   } catch (error) {
  //     console.error("There was an error deleting the seat plan!", error);
  //   }
  // };

  return (
    <React.Fragment>
      <AuthModal
        isOpen={isModalOpen}
        onClose={closeAuthModal}
        title="Action Verification"
        content={<div className='text-base mb-3'>Are you sure you want to delete this content?</div>}
        footer={
          <>
            <button 
              className="m-0 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
              onClick={closeAuthModal}>
              Close
            </button>
            <button 
              className="m-0 px-4 py-2 text-sm font-medium text-white bg-red-500 rounded hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400"
              onClick={confirmDelete}>
              Confirm
            </button>
          </>
        }
      />

      <div className="w-full p-5">
        <div className="flex justify-between items-center mb-4">
          <h2 className="GraphikSemibold text-[20px] text-[#1f2328] font-semibold">List of Seat Plan</h2>
          <CreateNew />
        </div>

        <div className="flex flex-col">
          <CurrentLatestSeatPlanTable items={items} loading={loading} onDelete={handleDelete} onEdit={handleEdit} />
        </div>
      </div>
    </React.Fragment>
  );
}
